import React from 'react';
import cn from '../../lib/cn';
import site from '../../data/site';
import Icon from '../ui/Icon';
import useScrollPosition from '../../hooks/useScrollPosition';

/**
 * Persistent call/WhatsApp affordance. Most visits to a jewellery showroom
 * site end in a phone call, so the number never goes more than a thumb away.
 */
export function FloatingContact() {
  const { scrolled } = useScrollPosition(520);

  return (
    <div
      className={cn(
        'fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3 transition-all duration-500 ease-silk',
        scrolled ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'
      )}
    >
      <a
        href={site.contact.phoneHref}
        aria-label={`Call ${site.shortName} on ${site.contact.phoneDisplay}`}
        className="grid h-12 w-12 place-items-center rounded-full border border-ink-900/10 bg-canvas text-ink-900 shadow-card transition hover:bg-ink-950 hover:text-canvas sm:hidden"
      >
        <Icon name="phone" size={18} />
      </a>

      <a
        href={site.contact.whatsappHref}
        target="_blank"
        rel="noreferrer noopener"
        className="group relative flex items-center gap-2.5 rounded-full bg-sunrise px-5 py-3.5 text-ink-950 shadow-[0_14px_34px_-14px_rgba(244,145,0,0.85)] transition-transform duration-300 ease-silk hover:-translate-y-0.5"
      >
        <span className="absolute inset-0 rounded-full border border-sun-400 animate-pulse-ring" aria-hidden="true" />
        <Icon name="whatsapp" size={18} />
        <span className="hidden text-[0.72rem] font-medium uppercase tracking-widest sm:inline">
          Enquire
        </span>
      </a>
    </div>
  );
}

export default FloatingContact;
